import { Condiment, Condiments } from '../../../models';
import { getRBPStringId } from '../../../page/main/main-page-states';
import http, { BASE_URL_3, OkPacket, ResponseErrorType } from '../../http';

const condimentsApi = {
  /**
   * 获取调味品组
   * with_group 是否按调味品组对调味品进行分组
   */
  async get_condiments_group(
    params: {
      with_group: boolean;
    },
    rbpStringId?: string,
  ): Promise<Condiments[]> {
    const sid = (rbpStringId && rbpStringId.trim()) || getRBPStringId();
    return await http.get(`${BASE_URL_3}/condiments/${sid}`, {
      params,
    });
  },
  /**
   * 新增调味品组
   */
  async post_condiments_group(params: {
    scomdiment_groups_id?: number;
    comdiment_groups_name: string;
  }): Promise<OkPacket> {
    return await http.post(
      `${BASE_URL_3}/condiment_group/${getRBPStringId()}`,
      { ...params },
    );
  },
  /**
   * 新增调味品
   */
  async post_condiment(params: Condiment): Promise<OkPacket> {
    const { scomdiment_groups_id, ...otherParams } = params as any;
    return await http.post(
      `${BASE_URL_3}/condiment_group/${scomdiment_groups_id}/condiment/${getRBPStringId()}`,
      otherParams,
    );
  },
  /**
   * 修改调味品组
   */
  async patch_condiment_group(params: {
    id: number;
    comdiment_groups_name: string;
  }): Promise<OkPacket> {
    return await http.patch(
      `${BASE_URL_3}/condiment_group/${params.id}/${getRBPStringId()}`,
      {
        comdiment_groups_name: params.comdiment_groups_name,
      },
    );
  },
  /**
   * 删除调味品组
   */
  async del_condiment_group(
    params: number[],
  ): Promise<OkPacket | ResponseErrorType> {
    return await http.delete(
      `${BASE_URL_3}/condiment_group/${getRBPStringId()}`,
      { data: [...params] },
    );
  },
  /**
   * 修改调味品patch_condiment
   */
  async patch_condiment(params: Condiment): Promise<OkPacket> {
    const { item_id, ...otherParams } = params as any;
    return await http.patch(
      `${BASE_URL_3}/condiment/${item_id}/${getRBPStringId()}`,
      otherParams,
    );
  },
  /**
   * 删除调味品
   */
  async del_condiment(params: number[]): Promise<OkPacket> {
    return await http.delete(`${BASE_URL_3}/condiment/${getRBPStringId()}`, {
      data: [...params],
    });
  },
  /**
   * 批量上传调味品
   */
  async mul_upload_condiment(params: any[]): Promise<OkPacket> {
    return await http.post(
      `${BASE_URL_3}/condiment_group/condiment/excel/${getRBPStringId()}`,
      { data: params },
    );
  },
};
export default condimentsApi;
